import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ArrowExpand3 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M11.8388 2.58333C11.4245 2.58333 11.0888 2.91912 11.0888 3.33333C11.0888 3.74755 11.4245 4.08333 11.8388 4.08333V2.58333ZM16.6667 3.33333H17.4167C17.4167 2.91912 17.0809 2.58333 16.6667 2.58333V3.33333ZM15.9167 8.16092C15.9167 8.57514 16.2525 8.91092 16.6667 8.91092C17.0809 8.91092 17.4167 8.57514 17.4167 8.16092H15.9167ZM11.0341 8.96552L10.5038 8.43517L10.5038 8.4352L11.0341 8.96552ZM8.16124 17.4167C8.57545 17.4167 8.91124 17.0809 8.91124 16.6667C8.91124 16.2525 8.57545 15.9167 8.16124 15.9167V17.4167ZM3.33333 16.6667H2.58333C2.58333 17.0809 2.91912 17.4167 3.33333 17.4167V16.6667ZM4.08333 11.8391C4.08333 11.4249 3.74755 11.0891 3.33333 11.0891C2.91912 11.0891 2.58333 11.4249 2.58333 11.8391H4.08333ZM11.8388 4.08333H16.6667V2.58333H11.8388V4.08333ZM15.9167 3.33333V8.16092H17.4167V3.33333H15.9167ZM16.1364 2.80299L10.5038 8.43517L11.5644 9.49587L17.197 3.86368L16.1364 2.80299ZM8.16124 15.9167H3.33333V17.4167H8.16124V15.9167ZM4.08333 16.6667V11.8391H2.58333V16.6667H4.08333ZM3.86368 17.197L11.5645 9.49584L10.5038 8.4352L2.80299 16.1363L3.86368 17.197Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ArrowExpand3
